// src/ProtectedRoute.js
import React from "react";
import { Route, Redirect } from "react-router-dom";

export default function ProtectedRoute({ component: Component, ...rest }) {
  const isAuthenticated = !!localStorage.getItem("bank.token"); // ou bank.session

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" /> // redirige vers login si pas connecté
        )
      }
    />
  );
}
